export default "__VITE_ASSET__CB6QHOSs__"